module.exports = __webpack_public_path__ + "img/9-06.3223e37b.png";